<template>
  <div class="layout-list">
    <div class="row">
      <div class="small-3 columns small-centered">
        <error-reveal :error="error"></error-reveal>
      </div>
    </div>
    <div class="row">
      <div class="small-3 columns small-centered">
        <flash-reveal :msg="flashMsg"></flash-reveal>
      </div>
    </div>
    <div class="row small-collapse">
      <div class="small-12 columns">
        <data-grid
          :items="items"
          :columns="columns"
          @additem="onAddNewItem"
          @itemaction="onItemAction"
          @refresh="onGridRefresh"
        ></data-grid>
      </div>
    </div>
    <data-store
      ref="store"
      :service="service"
      :filter="filter"
      :sort="sort"
      @beforeload="onBeforeLoad"
      @afterload="onAfterLoad"
      @dataloaded="onDataLoaded"
      @loaderror="onLoadError"
    ></data-store>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import DataGrid from '../../lists/DataGrid'
import DataStore from '../../data/Store'
import ErrorReveal from '../../errors/Reveal'
import FlashReveal from '../../flash/Reveal'
import analyticsService from '../../services/analytics'
import i18nService from '../../services/i18n'
import insightsService from '../../services/insights'

export default {
  name: 'analytics-list',
  components: {
    DataGrid,
    DataStore,
    ErrorReveal,
    FlashReveal
  },
  data () {
    return {
      items: [],
      columns: [{
      //   title: 'Létrehozva',
      //   name: 'createdAt',
      //   width: 140
      // }, {
        title: 'Megnevezés',
        name: 'title'
      }, {
        title: 'Oldal(ak)',
        name: 'channels'
      }, {
        title: 'Állapot',
        name: 'renderedState'
      }, {
        title: 'TOP 3 poszt',
        name: 'topPosts'
        // width: 180
      // }, {
      //   title: 'Beolvasás',
      //   name: 'readingInf',
      //   width: 180
      }, {
        actions: [{
          name: 'edit',
          html: '<i class="fi-page-edit"></i> Szerkesztés'
        }, {
          name: 'download',
          html: '<i class="fi-arrow-down"></i> Letöltés'
        }, {
          name: 'copy',
          html: '<i class="fi-page-copy"></i> Másolás'
        }],
        width: 150,
        align: 'center'
      }],
      service: analyticsService.list,
      filter: null,
      sort: null,
      error: null,
      flashMsg: null,
      insightsAnalytics: null
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onAddNewItem () {
      this.$router.push({name: 'analytics-edit'})
    },
    onBeforeLoad () {
      this[mutationTypes.BUSY_ON]()
    },
    onAfterLoad () {
      this[mutationTypes.BUSY_OFF]()
    },
    onDataLoaded (items, result) {
      this.items = items.map(this.parseItem)

      this[mutationTypes.BUSY_ON]()

      insightsService.loadSettings().then((data) => {
        this[mutationTypes.BUSY_OFF]()

        this.insightsAnalytics = data ? data.analytics : null
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    onLoadError (error) {
      this[mutationTypes.BUSY_OFF]()
      this.error = error
    },
    onItemAction (action, item) {
      if (action.name === 'edit') {
        this.$router.push({name: 'analytics-edit', params: {id: item.id}})
      }
      if (action.name === 'download') {
        this.onDownload(item)
      }
      if (action.name === 'copy') {
        this.onCopy(item)
      }
    },
    onGridRefresh () {
      this.$refs.store.load()
    },
    onDownload (item) {
      if (item.state === 'completed') {
        analyticsService.download(item.id)
      } else {
        this.error = new Error('Az elemzéshez még nem tartozik adat.')
      }
    },
    onCopy (item) {
      if (this.insightsAnalytics) {
        analyticsService.copy(item.id, this.insightsAnalytics._id).then((result) => {
          this.flashMsg = { message: 'Az elemzés másolása sikeresen megtörtént.', class: 'success' }
        }).catch((err) => {
          this.error = err
        })
      } else {
        this.error = new Error('Nincs beállítva kimutatás, így nem lehet másolni az elemzést.')
      }
    },
    parseItem (rawData) {
      return {
        id: rawData.id,
        createdAt: i18nService.formatDateTime(rawData.createdAt, i18nService.FMT_SHORT, i18nService.FMT_SHORT),
        title: rawData.title,
        channels: this.renderChannels(rawData.channels),
        state: rawData.state,
        renderedState: this.renderState(rawData.state),
        readingInf: i18nService.interval(rawData.readStartedAt, rawData.readEndedAt),
        topPosts: this.renderTopPosts(rawData.topPosts)
      }
    },
    renderChannels (channels) {
      var titles = []

      if (channels) {
        titles = channels.map((channel) => channel.name)
      }
      return titles.join(', ')
    },
    renderState (state) {
      var labels = {
        'draft': 'Vázlat',
        'pending': 'Várakozik',
        'reading': 'Beolvasás alatt',
        'completed': 'Kész'
      }
      return labels[state]
    },
    renderTopPosts (topPosts) {
      if (!topPosts || !topPosts.length) {
        return '-'
      }
      var blocks = topPosts.map((topPost, index) => {
        var consumption = _.get(topPost, 'insights.post_clicks_by_type|lifetime.values.sum')
        var impressions = _.get(topPost, 'insights.post_total_media_view_unique|lifetime.values.sum')
        var parts = []
        parts.push(`<span class="rank">${index + 1}</span>`)
        if (topPost.full_picture) {
          parts.push(`<img class="picture" src="${topPost.full_picture}" />`)
        }
        parts.push(`<p class="message">“${topPost.message}“</p>`)
        parts.push(`<p class="insights">Impressions: ${impressions}</p>`)
        parts.push(`<p class="insights">Consumption: ${consumption}</p>`)
        return parts.join('')
      })

      return '<div class="card-top-post">' + blocks.join('</div><div class="card-top-post">') + '</div>'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" ascoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/list';

  .card-top-post {
    width: 220px;
    background-color: #fff;
    min-height: 150px;
    float: left;
    border: 1px solid $primary-color;
    margin: 5px;
    padding: 5px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    position: relative;

    .rank {
      display: inline-block;
      background-color: #f00000;
      border: 5px solid #f00000;
      padding: 0 2px;
      color: #fff;
      font-weight: bold;
      font-size: 90%;
      line-height: 90%;
      // padding: 3px;
      -webkit-border-radius: 15px 15px 15px 15px;
      -moz-border-radius: 15px 15px 15px 15px;
      border-radius: 15px 15px 15px 15px;
      position: absolute;
      left: -5px;
      top: -5px;
    }

    p {
      margin: 0 0 3px 0;
    }
    .message {
      font-style: italic;
      padding: 3px 0px;
      line-height: 100%;
    }
    .picture {
      max-width: 200px;
      max-height: 100px;
      border: 1px solid #777;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      margin-bottom: 5px;
    }
    .insights {
      margin: 0;
      padding: 0;
      line-height: 110%;
    }
  }
</style>



// WEBPACK FOOTER //
// List.vue?87bec492